module.exports = {"id":"216476","name":"Anderson Plata","rating":"74","photo":"./data/images/photos/1/216476.png","club":{"name":"Ind. Santa Fe","logo":"./data/images/clubs/Ind.SantaFe.png"},"positions":["BU","AD","MD"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AndersonPlata0.json
// module id = 325
// module chunks = 0